import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Container } from 'web-ui-components/lib/global/layout';
import { TextStyled } from 'web-ui-components/lib/atoms/text';
import content, { contentPropTypes } from './BusinessCutOffModal.content';
import withContent from '../../containers/withContent';

export const BusinessCutOffModal = ({
	content: { modalAuthoriseLaterButton, modalCancelPaymentButton, modalTitle = '', modalBody = '' },
	isOpen,
	handleCancelPayment,
	handleAuthoriseLater,
}) => (
	<Modal isOpen={isOpen} shouldCloseOnOverlayClick={false}>
		<Container className="modal__container u-padding-y-4 u-text-align-center">
			<Icon iconType="ExclamationCircleLarge" size="lg" className="u-margin-x-auto u-margin-bottom-2" />
			<h3>{modalTitle}</h3>
			<TextStyled size="bute">{modalBody}</TextStyled>
			<div className="u-margin-bottom-2">
				<Button
					className="u-margin-top-2"
					id="businessCuttOffModalBtn"
					onClick={handleAuthoriseLater}
					width="flush"
					display="primary"
				>
					{modalAuthoriseLaterButton}
				</Button>
			</div>
			<div>
				<Button id="businessCuttOffCancelBtn" onClick={handleCancelPayment} width="flush">
					{modalCancelPaymentButton}
				</Button>
			</div>
		</Container>
	</Modal>
);

BusinessCutOffModal.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	isOpen: PropTypes.bool.isRequired,
	handleCancelPayment: PropTypes.func.isRequired,
	handleAuthoriseLater: PropTypes.func.isRequired,
};

export default withContent({ content })(BusinessCutOffModal);
